import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AdminWalletHistory } from "../components/userPoint/AdminWalletHistory";

export const UserPointPageList = () => {
  return (
    <MasterLayout>
      <AdminWalletHistory />
    </MasterLayout>
  );
};
